"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectFactFundModalCreate from "./controller/factFundModalCreate";
import ProjectFactFundTableDirective from "./directive/projectFactFundTable";

export default angular
  .module("investmentProject.project.fund.fact", [])
  .controller(
    "ProjectFactFundModalCreateController",
    ProjectFactFundModalCreate
  )
  .directive("projectFactFundTable", ProjectFactFundTableDirective).name;
